/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentAIAnalysis
 */
export interface DocumentAIAnalysis {
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    tldr?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentAIAnalysis
     */
    analysis?: string;
}

/**
 * Check if a given object implements the DocumentAIAnalysis interface.
 */
export function instanceOfDocumentAIAnalysis(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentAIAnalysisFromJSON(json: any): DocumentAIAnalysis {
    return DocumentAIAnalysisFromJSONTyped(json, false);
}

export function DocumentAIAnalysisFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentAIAnalysis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tldr': !exists(json, 'tldr') ? undefined : json['tldr'],
        'analysis': !exists(json, 'analysis') ? undefined : json['analysis'],
    };
}

export function DocumentAIAnalysisToJSON(value?: DocumentAIAnalysis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tldr': value.tldr,
        'analysis': value.analysis,
    };
}

